import { useTranslation } from 'react-i18next';

import { Modal, ModalProps } from '@mantine/core';

import { StyledButton } from 'components/shared';

import styles from './CannotDeactivateClientModal.module.css';

const CannotDeactivateClientModal = (props: ModalProps) => {
   const { t } = useTranslation();

   return (
      <Modal size={600} title={t('cannot_deactivate_client.title')} centered {...props}>
         <div className={styles.modalContent}>
            <p>{t('cannot_deactivate_client.line_1')}</p>
            <p>{t('cannot_deactivate_client.line_2')}</p>
            <StyledButton
               onClick={props.onClose}
               variant="outlined-danger"
               text={t('cancel_pallet_report_modal.back')}
            />
         </div>
      </Modal>
   );
};

export default CannotDeactivateClientModal;
